module.exports = __webpack_public_path__ + "static/havlu-mrc-be946126bf56d3807328f47e98b4519c.jpg";